import { cn } from "@faire/react/tools/cn";

/**
 * Full Story tracking class for icons. Mirrors the `ICON` case of Slate's
 * `getTrackingCls` (`@faire/slate/lib/tracking`) without pulling in the rest of
 * Slate's tracking machinery, so the icon set stays a leaf.
 */
export const iconCls = (...cls: Array<string | undefined>) =>
  cn(...cls, "fs-icon");
